/**
 * Created by Ning Jiang on 10/31/2018.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Back, TimelineLite, TweenLite} from "gsap";
import {TombstoneGameConfig} from "../../TombstoneGameConfig";
import {ShootingAnimation} from "../ShootingAnimation";
import {TombstoneGameModuleConfig} from "../../TombstoneGameModuleConfig";

export class TombstoneBonusSymbolWPView extends BaseView {

    private readonly _sparkPositions:[number, number][] = [[570 + 12 - 640, 141 + 14 - 360], [669 + 12 - 640, 228 + 14 - 360], [700 + 12 - 640, 273 + 14 - 360]];
    private readonly _sparkDelays:number[] = [0.1, 0.3, 0.5];

    private _layer:ScalableLayer;
    private _introContainer:PIXI.Container;
    private _darkOverlay:PIXI.Graphics;
    private _rays:TimelineSprite;
    private _number:PIXI.Sprite;
    private _featureName:TimelineSprite;
    private _isPlaying:boolean = false;

    constructor() {
        super();
    }

    protected initAnimations():void {
        this._layer = StageManager.getLayer(TombstoneGameConfig.instance.LAYERS.JUSTICE_INTRO.name);

        this._darkOverlay = new PIXI.Graphics();
        this._darkOverlay.alpha = 0;
        this._layer.addChild(this._darkOverlay);

        this._introContainer = new PIXI.Container();
        this._introContainer.alpha = 0;
        this._introContainer.position.set(GameConfig.instance.GAME_WIDTH / 2, GameConfig.instance.GAME_HEIGHT / 2);
        this._layer.addChild(this._introContainer);

        this._rays = new TimelineSprite(GameResources.getTextures("bigWinRays"));
        this._rays.blendMode = PIXI.BLEND_MODES.SCREEN;
        this._rays.anchor.set(0.5);
        this._introContainer.addChild(this._rays);

        this._number = new PIXI.Sprite(GameResources.getTextures("respinIntro3")[0]);
        this._number.anchor.set(0.5);
        this._number.position.set(0, -136);
        this._introContainer.addChild(this._number);

        this._featureName = new TimelineSprite(GameResources.getTextures("justiceSpins"));
        this._featureName.anchor.set(0.5);
        this._featureName.position.set(0, 73);
        this._featureName.hide();
        this._introContainer.addChild(this._featureName);
    }

    public addIntroToTimeline(timeline:TimelineLite):void {
        const resetTimeline:TimelineLite = new TimelineLite();

        timeline.add(() => {
            this._isPlaying = true;
            if(this._isResizeDirty) {
                this.onResize(this._resizeData);
            }
            TombstoneGameModuleConfig.TBBWController.hideCountUp();
        });

        timeline.add([
            TweenLite.to(this._introContainer, 0.1, {alpha : 1}),
            TweenLite.to(this._darkOverlay, 0.1, {alpha : 1}),
            TweenLite.fromTo(this._rays.scale, 0.6, {x : 1, y : 1}, {x : 1.5, y : 1.5}),
            TweenLite.fromTo(this._number, 0.55, {alpha : 0}, {alpha : 1}),
            TweenLite.fromTo(this._number.scale, 0.55, {x : 2, y : 2}, {x : 1, y : 1, ease : Back.easeIn.config(1.4)}),
            () => this._rays.playLoop()
        ]);
        timeline.add(this._featureName.getAnimationAutoShowHide(true, false), 0.55);
        timeline.addLabel("displayed", "+=0");
        this._sparkPositions.forEach((positions:[number, number], index:number) => {
            const shootingAnimation:ShootingAnimation = new ShootingAnimation();
            shootingAnimation.createAnimation(this._introContainer, this._introContainer, positions, positions);
            timeline.add(shootingAnimation, `displayed+=${this._sparkDelays[index]}`);
            resetTimeline.add(() => shootingAnimation.reset());
        });

        timeline.add(TweenLite.to(this._introContainer, 0.2, {alpha : 0}), "+=2"); // show it for a while
        timeline.add(TweenLite.to(this._darkOverlay, 0.2, {alpha : 0}), "-=0.1");

        timeline.add(() => {
            this._rays.stopLoop();
            this._featureName.hide();
            this._isPlaying = false;
        });
        timeline.add(resetTimeline);
    }

    protected onResize(resizeData:IResizeData):void {
        this._resizeData = resizeData;

        if(!this._isPlaying) {
            this._isResizeDirty = true;
            return;
        }

        const screenWidth:number = resizeData.width / this._layer.scale.x;
        const screenHeight = resizeData.height / this._layer.scale.y;
        const leftOffset = -this._layer.x / this._layer.scale.x;
        const topOffset = -this._layer.y / this._layer.scale.y;

        this._darkOverlay.clear();
        this._darkOverlay.beginFill(0x000000, 0.8);
        this._darkOverlay.drawRect(leftOffset, topOffset, screenWidth, screenHeight);
        this._isResizeDirty = false;
    }
}